import React, { useState, useEffect, useMemo } from 'react';

const CountdownTimer = ({ initialSeconds,setCount,count, setTimer }) => {

  useEffect(() => {
    
    if (initialSeconds === 0) {
      setCount(true)
      return
    }else{
      setCount(false)
    }
    
    const timer = setInterval(() => {
      setTimer((prev) => prev - 1);

    }, 1000);



    return () => {
      clearInterval(timer)
      };
  }, [initialSeconds]);

const formattedTime = useMemo(()=>{
  const minutes = Math.floor(initialSeconds / 60);
  const seconds = initialSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

},[initialSeconds])

  // useEffect(() => {
    
  //   setCount(false)
  //     setTimeLeft(initialSeconds); 
  // }, [initialSeconds]);
  return <div   className="mt-5 text-center fs-4 fw-bold">{formattedTime}</div>;
};

export default CountdownTimer;